import { render, staticRenderFns } from "./InstallmentBatchTypeForm.vue?vue&type=template&id=688443ab&"
import script from "./InstallmentBatchTypeForm.vue?vue&type=script&lang=js&"
export * from "./InstallmentBatchTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports